import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=5282f270&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=5282f270&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282f270",
  null
  
)

export default component.exports